import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { settingsApi } from '@/lib/api/settings'
import { QUERY_KEYS } from '@/lib/api/query-client'
import { useToast } from '@/lib/hooks/use-toast'
import { SettingsResponse } from '@/lib/types/api'
import { useI18n } from '@/lib/hooks/use-i18n'

export function useSettings() {
  return useQuery({
    queryKey: QUERY_KEYS.settings,
    queryFn: () => settingsApi.get(),
  })
}

export function useUpdateSettings() {
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { t } = useI18n()

  return useMutation({
    mutationFn: (data: Partial<SettingsResponse>) => settingsApi.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.settings })
      toast({
        title: t('settings.toast.update.success.title'),
        description: t('settings.toast.update.success.description'),
      })
    },
    onError: () => {
      toast({
        title: t('settings.toast.update.error.title'),
        description: t('settings.toast.update.error.description'),
        variant: 'destructive',
      })
    },
  })
}
